import {
  Card,
  CardErrorBoundaryWithSpinfinity,
  DesignButton,
  Typography,
} from 'components';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { useTrackImpression } from 'contexts/analytics/useTrackImpression';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { useLocation, useNavigate } from 'react-router-dom';
import ConditionMetricsBoxes from './ConditionMetricsBoxes';

export function ConditionMetricsGridCard() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();
  const { trackEvent } = useAnalytics();
  const impressionRef = useTrackImpression(
    'Conditions Module Seen In Results Page',
    currentKit ? currentKitId : undefined,
    { experience: 'legacy_conditions' },
  );

  function handleNavigate() {
    trackEvent('Legacy Conditions Module Clicked In Results Page', {
      experience: 'legacy_conditions',
      clicked: 'view_all',
    });
    navigate(`${pathname}/conditions/metrics`, { state: { from: pathname } });
  }

  return (
    <CardErrorBoundaryWithSpinfinity cardName='ConditionMetricsGridCard'>
      <Card title='Condition associations'>
        <div ref={impressionRef} className='flex flex-column'>
          <Typography variant='body-s'>
            This section helps you explore which metrics are commonly associated
            with different symptoms or conditions. This is not a diagnosis.
          </Typography>
          <ConditionMetricsBoxes />
          <DesignButton color='purple' width='full' onClick={handleNavigate}>
            View all health associations
          </DesignButton>
        </div>
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
}
